const easterCardData = {
  link: '/occasion/easter-gift-hampers/',
  title: 'Limited Edition Easter Hampers',
  name: 'Limited Edition Easter Hampers',
  image: {
    sourceUrl:
      'https://cart.gourmetbasket.com.au/wp-content/uploads/2024/02/Easter-Tile-scaled.jpg',
    altText: 'Limited Edition Easter Hampers',
    sizes: '',
    title: 'Limited Edition Easter Hampers',
  },
  id: 20668623,
};

export default easterCardData;
